import { useEffect } from "react";

/**
 * Hook para detectar cliques fora de múltiplos elementos.
 *
 * @param refs - Array de referências para monitorar cliques externos
 * @param callback - Função a ser executada quando um clique externo é detectado
 */
export const useClickOutside = (
  refs: React.RefObject<HTMLElement>[],
  callback: () => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isClickOutside = refs
        .filter((ref) => ref.current !== null)
        .every((ref) => !ref.current!.contains(event.target as Node));

      if (isClickOutside) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, callback]);
};
